var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.75,
    height: 12.007,
    viewBox: "0 0 15.75 12.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M15.531-5.469l-5.25,5.25a.7.7,0,0,1-.812.156A.685.685,0,0,1,9-.75v-3H4.75a.723.723,0,0,1-.531-.219A.723.723,0,0,1,4-4.5v-3a.723.723,0,0,1,.219-.531A.723.723,0,0,1,4.75-8.25H9v-3a.685.685,0,0,1,.469-.687.7.7,0,0,1,.813.156l5.25,5.25A.723.723,0,0,1,15.75-6,.723.723,0,0,1,15.531-5.469ZM6-.375A.331.331,0,0,1,5.625,0H3A2.893,2.893,0,0,1,.875-.875,2.893,2.893,0,0,1,0-3V-9a2.893,2.893,0,0,1,.875-2.125A2.893,2.893,0,0,1,3-12H5.625A.331.331,0,0,1,6-11.625v1.25A.331.331,0,0,1,5.625-10H3a.961.961,0,0,0-.7.3A.961.961,0,0,0,2-9v6a.961.961,0,0,0,.3.7A.961.961,0,0,0,3-2H5.625A.331.331,0,0,1,6-1.625Z",
    transform: "translate(0 12.004)",
    fill: "#5d6373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.a443a20170110b2cf29fba955607f5b6.svg";
export { ForwardRef as ReactComponent };